//待办抽离
import {apiUserTaskQueryFlownodeList,apiUserTaskTotal} from '@/server/new.js';
const mixin = {
    filters: {
        historyidFilter: (type) => {
            switch(type){
                case 0:return '已完成';break;
                case -1:return '待处理';break;
                default:return '待处理';break;
            }
        },
        projectTypeMapperName(type,prop){
            if(prop === 'datasetCode') {
                return type;
            }
            switch(type){
                case 'GC':return '工程建设';break;
                case 'CG':return '政府采购';break;
                case 'XT':return '协同办公';break;
                case 'QT':return '其他';break;
            }
        },
        formatterFilter:(value,key) => {
            let slashFormatterList = ['finishTime'] //哪些字段空需要转/
            if(slashFormatterList.indexOf(key) !=-1) {
                if(!value) return '/';
            }
            return value;
        }
    },
    data() {
        return {
            loading: false,
            tableData: [],
            total: 0,
            pageSize: 20,
            pageIndex: 1,
            sortParams: {
                prop: '',
                order: ''
            },
        }
    },
    mounted() {
        this.apiUserTaskQueryFlownodeList();
    },
    methods: {
        setProjectClass(value,prop) { //设置project样式
            let temp={
				'GC':'project_GC',
				'CG':'project_CG',
				// 'CQ':'project_CQ',
				'XT':'project_GT',
				'QT':'project_QT',
                'datasetCode': ''
			}
            if(prop === 'datasetCode') {
                return 'project_CG';
            }
			return temp[value];
        },
        apiUserTaskQueryFlownodeList() { //获取业务节点数据
            apiUserTaskQueryFlownodeList({
                busType: this.dataForm.taskType
            }).then(({data}) => {
                data.data.forEach(item => {
                    item.value = item.datasetCode;
                    item.text = item.nodeName;
                })
                this.columns.forEach(item => {
                    if(item.prop === 'datasetCode') {
                        item.filters = data.data || [];
                    }
                })
            })
        },
        apiUserTaskTotal(value,historyid) { //获取待办数量 value类型
            let processDateStart = this.processDate?this.processDate[0]:null;
            let processDateEnd = this.processDate?this.processDate[1]:null;
            let finishTimeStart = this.finishTime?this.finishTime[0]:null;
            let finishTimeEnd = this.finishTime?this.finishTime[1]:null;
            apiUserTaskTotal({
                searchKey: this.dataForm.searchKey,
                filter: {
                    taskType: value,
                    historyid: historyid || this.dataForm.historyid,
                    datasetCodeList: this.dataForm.datasetCodeList,
                    processDateStart,
                    processDateEnd,
                    finishTimeStart,
                    finishTimeEnd,
                    regionCode: this.dataForm.regionCode,
                }
            }).then(({data}) => {
                this.navList.forEach(item => {
                    if(item.value == value) {
                        item.num = data.data || 0;
                    }
                })
                if(this.flag) {
                    this.flagIndex += 1;
                        if(this.flagIndex === this.navList.length) {
                            for(let item of this.navList) {
                                if(item.num) {
                                    this.dataForm.taskType = item.value;
                                    this.fetchData();
                                    return;
                                }
                            }
                            this.dataForm.taskType = 'GC';
                            this.fetchData();
                        }
                }
            })
        },
        sortChange({ column, prop, order }) { //排序触发
            this.sortParams.prop = prop || column.prop;
            this.sortParams.order = order || column.order;
            this.fetchData();
        },
        
        filterChange(list) { //筛选触发
            // console.log(list)
            Object.keys(list).forEach((key) => {
                if(key === 'datasetCode') {
                    this.dataForm.datasetCodeList = list.datasetCode;
                }
            });
            this.fetchData();
        },
        navHandler(row) { //nav点击
            this.dataForm.taskType = row.value;
            this.pageIndex = 1;
            if(this.flag) {
                this.pageSize = 5;
            }else {
                this.pageSize = 20;
            }
            this.fetchData();
            this.apiUserTaskQueryFlownodeList();
        },
        paginationChange(obj){
         this.pageIndex= obj.page||1
         this.pageSize=obj.limit||5
         this.fetchData();
        },
        sizeChangeHandle(value) { //pageSize修改
            this.pageSize = value;
            this.pageIndex = 1;
            this.fetchData();
        },
        currentChangeHandle(value) { //pageIndex修改
            this.pageIndex = value;
            this.fetchData();
        },
        indexMethod(index) { //序号
            return (this.pageIndex - 1) * this.pageSize + index + 1
        },
    },
    beforeDestroy() {
        this.dataForm.taskType = '';
    }
}
export default mixin;